import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const modalBody = css`
  inline-size: ${spacing(82.5)};
  min-block-size: 40rem;
  justify-content: center;
  align-items: stretch;
`
